module.exports = __webpack_public_path__ + "static/media/logo.57e864dd.png";